import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/arrow-small-right.svg'


const _hoisted_1 = { class: "project-picker-sidebar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Projects", -1)
const _hoisted_3 = {
  id: "project-accordion",
  class: "accordion-flush pt-4"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<img class=\"icon me-2\" src=\"" + _imports_0 + "\"><svg class=\"folder-icon me-3\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_822_9895)\"><path d=\"M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V8H20V18Z\"></path></g><defs><clipPath id=\"clip0_822_9895\"><rect width=\"24\" height=\"24\"></rect></clipPath></defs></svg>", 2)
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "accordion-body" }
const _hoisted_10 = {
  key: 0,
  class: "list-group-flush surveys"
}
const _hoisted_11 = { class: "list-group-item add-survey" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15 9.75H9.75V15H8.25V9.75H3V8.25H8.25V3H9.75V8.25H15V9.75Z" })
], -1)

import { Utils } from "@/classes/utils/utils";
import NewSurveyDialog from "@/components/Modals/NewSurveyDialog.vue";
import router from "@/router";
import { useAppStateStore } from "@/store/app-state";
import { useDataStore } from "@/store/data-store";
import { useUserStore } from "@/store/user-store";
import { ProjectInfo, Survey } from "@/swagger";
import { onMounted, onUnmounted, WatchStopHandle, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";

interface ProjectSurveyInfo extends ProjectInfo {
	isLoading?: boolean;
	surveys?: Survey[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectPickerSidebar',
  setup(__props) {

const route = useRoute();
const dataStore = useDataStore();
const userStore = useUserStore();
const appState = useAppStateStore();
let appStateWatchHandle: WatchStopHandle | null = null;
const newSurveyDialog = ref();

const state = reactive({
	projects: [] as ProjectSurveyInfo[],
	// selectedProjectUUID: null as string | null
});

async function loadProjectSurveys(project: ProjectSurveyInfo) {
	if (project.uuid == appState.project?.uuid) {
		router.replace({ name: "edit" })
	} else {
		router.replace({ params: { projectId: project.uuid } })
	}
}

function onNewSurveyDialogClosed(survey?: Survey){
	if(survey){
		router.replace({params: {surveyId: survey.uuid}});
	}else{
		refreshSurveys();
	}
}

function onSurveyChanged() {
	const projectUUID = appState.project?.uuid;
	var project = state.projects.find((p) => p.uuid === projectUUID);
	if (project) {
		project.surveys = appState.project.surveys;
	}
}

function refreshSurveys() {
	appState.reloadCurrentProject();
}

function isSurveySelected(survey: Survey) {
	return appState.view1Survey?.uuid === survey.uuid;
}

function addNewSurvey() {
	newSurveyDialog.value.show();
}

onMounted(async () => {
	if (userStore.isLoggedIn()) {
		state.projects = await dataStore.getProjects(true);
		appStateWatchHandle = watch(appState, onSurveyChanged);
		console.log("Mounted");
		// var selectedProject = state.projects.find((p) => p.uuid === route.params.projectId);
		// if (selectedProject) {
		// 	loadProjectSurveys(selectedProject);
		// }
	}
	if(route.query.createNewSurvey){
		addNewSurvey();
	}
});

onUnmounted(() => {
	if (appStateWatchHandle) {
		appStateWatchHandle();
	}
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.projects, (project, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "accordion-item",
          key: project.uuid
        }, [
          _createElementVNode("h2", {
            class: "accordion-header",
            id: 'project-button-' + index
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["accordion-button", { 'collapsed': project.uuid !== _unref(appState).project?.uuid }]),
              type: "button",
              onClick: ($event: any) => (loadProjectSurveys(project))
            }, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(project.name) + " (" + _toDisplayString(_unref(Utils).formatBytes(project.size)) + ") ", 1)
            ], 10, _hoisted_5)
          ], 8, _hoisted_4),
          (_unref(appState).project)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: 'project-content-' + index,
                class: _normalizeClass(["accordion-collapse collapse", { 'show': project.uuid === _unref(appState).project.uuid }]),
                "data-bs-parent": "#project-accordion"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (project.surveys)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.surveys, (survey) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["list-group-item", { selected: isSurveySelected(survey) }]),
                            key: survey.uuid
                          }, [
                            _createElementVNode("img", {
                              class: _normalizeClass(["arrow-icon", { selected: isSurveySelected(survey) }]),
                              src: _imports_0
                            }, null, 2),
                            _createVNode(_component_router_link, {
                              to: { name: 'edit', params: { projectId: project.uuid, surveyId: survey.uuid } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(Utils).formatSurveyName(survey)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewSurvey()))
                          }, " Add new survey ")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_8))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createVNode(NewSurveyDialog, {
      projectuuid: _unref(appState).project?.uuid,
      "is-first-survey": _unref(appState).project?.surveys?.length == 0,
      ref_key: "newSurveyDialog",
      ref: newSurveyDialog,
      class: "new-survey-dialog",
      onOnHide: onNewSurveyDialogClosed
    }, null, 8, ["projectuuid", "is-first-survey"])
  ]))
}
}

})